"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  gallery: {
    wixInit: false,
    renderedItemsCount: 50,
    videoIndexPlay: -1,
    lastVideoPlayed: -1,
    isInView: true,
    documentHeight: _utils["default"].getScreenHeight()
  },
  fullscreen: {}
};
exports["default"] = _default;